import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
//import {TimelineLite} from 'gsap';

Snappy.Component.RelatedDocuments = class RelatedDocuments extends Snappy.BaseComponent {
    static get tagName() {
        return 'cfa-related-documents';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.init();

    }

    setVars() {
        this.numberToShow = 9;
        this.$items = this.$element.find('.js-item');
        this.$remainingCount = this.$element.find('.js-count');
        this.$additionalContainer = this.$element.find('.js-additional');
        this.$accordion = this.$element.find('.js-accordion');

    }

    init() {
        let documentCount = this.$items.length;
        if (documentCount <= this.numberToShow) {
            this.$accordion.addClass('is-hidden');
        }
        else {
            this.$remainingCount.text(documentCount - this.numberToShow);
            this.createAccordion();
        }

        this.$element.removeClass('is-before-init');
    }

    createAccordion() {
        let $additionalItems = this.$items.slice(this.numberToShow);
        this.$additionalContainer.append($additionalItems);

    }


};




// WEBPACK FOOTER //
// ./components/related-documents/scripts/related-documents.js